import { getPostPageProps } from 'props-getters/post'
import { ExtractGetterProps } from 'shared-definitions/util-types'
import PageContainer from 'shared-components/service/PageContainer'
import { logWarning } from 'shared-code/log'
import { GetStaticPaths } from 'next'
import { DSTplPage } from 'types.aa.ds'
import dynamic from 'next/dynamic'
import TextTemplate from 'templates/TextTemplate'
import PostTemplate from 'templates/PostTemplate'
import EventTemplate from 'templates/EventTemplate'
import Layout from 'components/Layout'
import Logo from 'shared-svg/LogoAA.svg'
import { DSLayoutProps } from 'shared-definitions/types'

const BestListTemplate = dynamic(() => import('templates/BestListTemplate'))
const ReviewTemplate = dynamic(() => import('templates/ReviewTemplate'))
const AboutTemplate = dynamic(() => import('shared-components/templates/AboutTemplate'))
const RootCategoryTemplateAA = dynamic(() => import('templates/RootCategoryTemplateAA'))
const TopicTemplateAA = dynamic(() => import('templates/TopicTemplateAA'))
const CategoryTemplate = dynamic(() => import('templates/CategoryTemplate'))
const DealsCategoryTemplateAA = dynamic(() => import('templates/DealsCategoryTemplateAA'))
const ContactsTemplate = dynamic(() => import('templates/ContactsTemplate'))
const SidedCategoryTemplate = dynamic(() => import('templates/SidedCategoryTemplate'))
const AltBestListTemplateAA = dynamic(() => import('templates/AltBestListTemplateAA'))

interface DSPageTplResult {
  tpl: React.ReactElement | null
  layoutProps: DSLayoutProps
}

function getPageTpl(page: DSTplPage): DSPageTplResult {
  switch (page.resource) {
    case 'about-page':
      return { tpl: <AboutTemplate page={page} logo={Logo} />, layoutProps: {} }
    case 'category-page':
      return { tpl: <CategoryTemplate page={page} />, layoutProps: {} }
    case 'deals-category-page':
      return { tpl: <DealsCategoryTemplateAA page={page} />, layoutProps: {} }
    case 'sided-category-page':
      return { tpl: <SidedCategoryTemplate page={page} />, layoutProps: {} }
    case 'contact-page':
      return { tpl: <ContactsTemplate page={page} />, layoutProps: {} }
    case 'text-page':
      return { tpl: <TextTemplate page={page} />, layoutProps: {} }
    case 'post-page':
      return { tpl: <PostTemplate page={page} />, layoutProps: {} }
    case 'event-page':
      return { tpl: <EventTemplate page={page} />, layoutProps: {} }
    case 'review-page':
      return { tpl: <ReviewTemplate page={page} />, layoutProps: {} }
    case 'best-list-page':
      return { tpl: <BestListTemplate page={page} />, layoutProps: {} }
    case 'root-category-page':
      return { tpl: <RootCategoryTemplateAA page={page} />, layoutProps: {} }
    case 'topic-page':
      return { tpl: <TopicTemplateAA page={page} />, layoutProps: {} }
    case 'alt-best-list-page':
      return {
        tpl: <AltBestListTemplateAA page={page} />,
        layoutProps: {
          tocVisibility: {
            default: false,
            breakpoints: {},
          },
        },
      }
    default:
      logWarning('Unknown tpl page', page)
      return { tpl: null, layoutProps: {} }
  }
}

const TplPage: React.VFC<ExtractGetterProps<typeof getPostPageProps>> = ({
  preview,
  page,
  common,
  ts,
}) => {
  const { tpl, layoutProps } = getPageTpl(page)
  return (
    <PageContainer
      layoutProps={layoutProps}
      layout={Layout}
      props={{ tooltips: 'tooltips' in page ? page.tooltips : {}, page, common, ts, preview }}
    >
      {tpl}
    </PageContainer>
  )
}

export const getStaticPaths: GetStaticPaths = () =>
  Promise.resolve({
    paths: [],
    fallback: 'blocking',
  })

export const getStaticProps = getPostPageProps()

export default TplPage
